<template>
  <div class="top-section">
    <div class="header-gradient" v-if="this.$route.path == '/'">
      <v-vanta effect="waves" :options=options></v-vanta>
      <div class="white-diag"></div>
    </div>
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-2 col-md-3 col-sm-6 col-5">
            <router-link :to="{ name: 'home' }">
              <img class="header-logo" v-if="this.$route.path == '/'" :src="gunspring_logo_white" />
              <img class="header-logo" v-else :src="gunspring_logo" />
            </router-link>
          </div>
          <div class="col-xl-9 col-lg-10 col-md-9 col-sm-6 col-7 text-right">
            <ul class="header-links">
              <li>
                <a href="/" v-bind:class="headerLinkColor">platform</a>
              </li>
              <li>
                <a href="/" v-bind:class="headerLinkColor">solutions</a>
              </li>
              <li>
                <a href="/" v-bind:class="headerLinkColor">pricing</a>
              </li>
              <li>
                <a href="/" v-bind:class="headerLinkColor">resources</a>
              </li>
              <li>
                <a href="/" v-bind:class="headerLinkColor">blog</a>
              </li>
              <!-- <li>
                <router-link :to="{ name: 'support' }">Support</router-link>
              </li> -->
              <li>
                <a href="/" v-bind:class="headerLinkColor">support</a>
              </li>
              <li v-if="accessToken!=null">
                <router-link :to="{ name:'logout' }" v-bind:class="headerLinkColor">Log out</router-link>
              </li>
              <li v-else>
                <router-link :to="{ name:'login' }" v-bind:class="headerLinkColor">Log in</router-link>
              </li>
            </ul>
            <router-link
              v-bind:class="headerRequestDemo"            
              class="header-request-demo"
              :to="{ name: 'admin' }"
              v-if="accessToken && isadmin=='superuser'"
            >Dashboard</router-link>
            <router-link
              v-bind:class="headerRequestDemo"            
              class="header-request-demo"
              :to="{ name: 'userapps' }"
              v-else-if="accessToken!=null"
            >Dashboard</router-link>
            <router-link
              v-bind:class="headerRequestDemo"
              :to="{ name: 'register' }"
              v-else
            >Sign Up</router-link>
            <span class="mobile-menu-button inactive">
              <i class="fas fa-bars fa-lg"  v-bind:class="hamburgerIconColor"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-menu">
      <div class="mobile-menu-header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-6">
              <router-link :to="{ name: 'home' }">
                <img class="header-logo" :src="gunspring_logo" />
              </router-link>
            </div>
            <div class="col-6 text-right">
              <i class="fas fa-times fa-lg mobile-menu-close-button"></i>
            </div>
          </div>
          <div class="mobile-menu-content text-center">
            <ul class="mobile-menu-links">
              <li>
                <a href="#">platform</a>
              </li>
              <li>
                <a href="#">solutions</a>
              </li>
              <li>
                <a href="#">pricing</a>
              </li>
              <li>
                <a href="#">resources</a>
              </li>
              <li>
                <a href="#">blog</a>
              </li>
              <li>
                <router-link :to="{ name: 'support' }">support</router-link>
              </li>
              <li v-if="accessToken!=null">
                <router-link :to="{ name:'logout' }">Log out</router-link>
              </li>
              <li v-else>
                <router-link :to="{ name:'login' }">Log in</router-link>
              </li>
            </ul>
            <router-link
              class="header-request-demo"
              :to="{ name: 'admin' }"
              v-if="accessToken && isadmin=='superuser'"
            >Dashboard</router-link>
            <router-link
              class="header-request-demo"
              :to="{ name: 'userapps' }"
              v-else-if="accessToken!=null"
            >Dashboard</router-link>
            <router-link
              class="header-request-demo"
              :to="{ name: 'register' }"
              v-else
            >Sign Up</router-link>
            <div class="mobile-menu-footer text-center">
              <router-link
              :to="{name:'privacy'}">Privacy</router-link>
              <router-link
              :to="{name:'terms-of-service'}">Terms of Service</router-link>
              <router-link
              :to="{name:'about-gunspring'}">About Gunspring</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


</script> 
<script>
import { mapState } from "vuex";
import VVanta from 'vue-vanta';
export default {
  components: { VVanta },
  name: "Header",
  props: {
    msg: String
  },

 data () {
    return {
      gunspring_logo_white: require("@/assets/images/gunspring-logo-white.svg"),
      gunspring_logo: require("@/assets/images/gunspring-logo.svg"),
      options: {
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 560.00,
        minWidth: 200.00,
        scale: 1.00,
        scaleMobile: 1.00
        }
      }
    },  
  computed: {
    accessToken () {
    return this.$store.state.accessToken
  },
  isadmin () {
    return this.$store.state.isadmin
  },
  headerLinkColor: function () {
    if (this.$route.path == "/") {
      return "header-white-link";
    } else {
      return "header-black-link";
    }
  },
  headerRequestDemo: function () {
    if (this.$route.path == "/") {
      return "header-request-demo-white";
    } else {
      return "header-request-demo";
    }    
  },
  hamburgerIconColor: function () {
    if (this.$route.path == "/") {
      return "white-color";
    }   
  }
},
};
</script>
